<template>
    <div class="order">
        <van-nav-bar title="家长通讯录" left-arrow @click-left="$router.go(-1)" />

        <div v-if="list.length == 0">
            <van-empty description="暂无记录" />
        </div>
        <div v-else>
            <div v-for="item, index in list" :key="index">
                <van-collapse v-model="activeName" accordion @change="activeChange">
                    <van-collapse-item :title="`${item.class_name}（${item.parent_list.length}人）`" :name="item.class_name">
                        <van-row v-for="value,index in item.parent_list" :key="index"
                            style="padding: 10px 10px;margin: 10px 10px;background-color: white;border-radius: 20px;"
                            @click="showSheet(value.phone)">
                            <van-col span="6">
                                <van-image round width="60px" height="60px" src="/img/parents.png" />
                            </van-col>
                            <van-col span="18">
                                <p style="font-size: 16px;color: black;font-weight: bold;">{{ value.realname }}</p>
                                <p style="font-size: 14px;color: grey;">手机号码: {{ value.phone }}</p>
                            </van-col>
                        </van-row>
                    </van-collapse-item>
                </van-collapse>

            </div>
        </div>
    </div>
</template>

<script>

import { stuGetParentBook } from '@/api/teacher'
export default {
    name: 'stuGetParentBook',
    components: {

    },
    data() {
        return {
            list: [],
            currentTeacher: {},
            activeName: ''
        }
    },
    mounted() {
        this.currentTeacher = JSON.parse(localStorage.getItem('userinfo'))
        this.getBook()
    },
    methods: {
        async getBook() {
            const params = {
                tid: this.currentTeacher.userId
            }
            const response = await stuGetParentBook(params)
            console.log('response', response);
            if (response.code == 10000) {
                this.list = response.data
            }
        },
        showSheet(phone) {
            if (!phone) {
                return
            }
            // 拨打电话
            window.location.href = `tel:${phone}`
        },
        activeChange(name) {
            console.log('当前展开的面板:', name);
            this.activeName = name
        },
    },
    watch: {

    }
}
</script>

<style lang="less" scoped>
.order {
    background-color: #fafafa;
}
</style>
